var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44982 4.5C4.6878 4.5 4.8916 4.4118 5.06121 4.2354C5.23054 4.0593 5.3152 3.8475 5.3152 3.6C5.3152 3.3525 5.23054 3.14055 5.06121 2.96415C4.8916 2.78805 4.6878 2.7 4.44982 2.7C4.21184 2.7 4.00819 2.78805 3.83886 2.96415C3.66924 3.14055 3.58444 3.3525 3.58444 3.6C3.58444 3.8475 3.66924 4.0593 3.83886 4.2354C4.00819 4.4118 4.21184 4.5 4.44982 4.5ZM4.44982 9C3.28876 7.9725 2.42165 7.01805 1.84847 6.13665C1.27501 5.25555 0.988281 4.44 0.988281 3.69C0.988281 2.565 1.33631 1.66875 2.03237 1.00125C2.72814 0.33375 3.53395 0 4.44982 0C5.36568 0 6.1715 0.33375 6.86727 1.00125C7.56333 1.66875 7.91136 2.565 7.91136 3.69C7.91136 4.44 7.62477 5.25555 7.0516 6.13665C6.47814 7.01805 5.61088 7.9725 4.44982 9Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4444dc911b65fe18e3c7d1c29047a059.svg";
export { ForwardRef as ReactComponent };